'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgHealthcard(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M12.572 3.71c.496 0 .676.052.858.149.182.097.324.24.421.421.097.182.149.362.149.858v5.715c0 .497-.052.677-.149.858-.097.182-.24.324-.421.422-.182.097-.362.148-.858.148H3.428c-.496 0-.676-.051-.858-.148a1.012 1.012 0 01-.421-.422c-.088-.163-.138-.325-.147-.718L2 5.138c0-.496.052-.676.149-.858.097-.182.24-.324.421-.421.163-.088.326-.138.719-.147l9.283-.002zm-7.06 4.395c-1.107 0-1.798.762-1.798 1.314 0 .188.12.291.485.291h2.63c.366 0 .485-.103.485-.29 0-.553-.69-1.315-1.801-1.315zm5.06-2.034a.571.571 0 00-.572.572v.57l-.571.001a.571.571 0 000 1.143h.57l.001.572a.571.571 0 001.143 0v-.573l.571.001a.571.571 0 100-1.143h-.572v-.571a.571.571 0 00-.57-.572zm-5.06-.214c-.453 0-.856.397-.856.925 0 .53.403.942.857.942.457 0 .86-.411.86-.947 0-.533-.403-.92-.86-.92z", fill: "currentColor" }))));
}

module.exports = SvgHealthcard;
//# sourceMappingURL=Healthcard.js.map
